import React, { FC, useRef, useState } from 'react';

import { MembersMeItem } from './MembersMeItem';
import { MembersItem } from './MembersItem';
import { useStore } from '@/app/providers/StoreProvider';
import { Virtuoso, ListRange } from "react-virtuoso";

function sortByBoolean<T>(arr: T[], key: keyof T, trueFirst: boolean = true): T[] {
  return [...arr].sort((a, b) => {
    const valA = a[key] ? 1 : 0;
    const valB = b[key] ? 1 : 0;
    return trueFirst ? valB - valA : valA - valB;
  });
}

export const MembersList: FC = () => {
  const { forecastStore,userStore } = useStore();
  const { user } = userStore;
  const { bets } = forecastStore;

  const myId = user.id;

  const sortWinnerBets = sortByBoolean(bets, 'isWin');
  const myBet = sortWinnerBets.find(x => x.userId === myId);
  const myPlace = sortWinnerBets.findIndex(x => x.userId === myId);


  const [visibleRange, setVisibleRange] = useState({ start: 0, end: bets.length });
  const firstRangeSkipped = useRef(false);

  const handleRange = (range: ListRange) => {
    if (!firstRangeSkipped.current) {
      firstRangeSkipped.current = true;
      return;
    }
    setVisibleRange({ start: range.startIndex, end: range.endIndex });
  };

  const isMeVisible = myPlace >= visibleRange.start && myPlace <= visibleRange.end;

  return (

    <>
        <Virtuoso
        style={{ height: "calc(100% - 53px)" }}
        totalCount={bets.length}
        rangeChanged={handleRange}
        useWindowScroll={false}
        components={{
          Footer: () => (
            <div style={{ height: 50 }} />
          )
        }}
        itemContent={(index) => {
          const item = sortWinnerBets[index];
          return item.userId !== myId
            ? <MembersItem place={index + 1} user={item} />
            : <MembersMeItem place={myPlace + 1} user={myBet!} />;
        }}
      />

      {(!isMeVisible && myBet) && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 999,
          }}
        >
          <MembersMeItem place={myPlace + 1} user={myBet} />
        </div>
      )}

    </>

  );
};
